import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import Link from 'gatsby-link';

const Wrapper = styled.div`
  padding-left: 5%;
  padding-right: 5%;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background-color: hsl(0, 0%, 94%);
  border-bottom: 1px solid hsl(0, 0%, 88%);
  font-size: 11px;
  color: hsl(0, 0%, 39%) !important;
  line-height: 30px;
`;

const cnFooterCopy = css`
  display: inline-block;
  width: 50%;
`;

const cnFooterMenu = css`
  display: inline-block;
  width: 50%;
  padding: 0;
  text-align: right;
`;

const cnLink = css`
  text-decoration: none;
`;

const FooterLegal = ({ year }) => (
  <Wrapper>
    <div className={cnFooterCopy}>© {year} Stephan Herzog</div>
    <div className={cnFooterMenu}>
      <nav>
        <Link to="/" href="/" className={cnLink}>
          Home
        </Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Link to="/pbits/" href="/pbits/" className={cnLink}>
          PBits
        </Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Link to="/impressum/" href="/impressum/" className={cnLink}>
          Impressum
        </Link>
      </nav>
    </div>
  </Wrapper>
);

FooterLegal.propTypes = {
  year: PropTypes.string,
};
FooterLegal.defaultProps = {
  year: `${new Date().getUTCFullYear()}`,
};

export default FooterLegal;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/FooterLegal/FooterLegal.jsx